'use strict'

import ClientQueueItem from '@/app/model/clients/client-queue-item'

class ClientsQueue {
  constructor ({ items }) {
    this.items = items.map((item) => new ClientQueueItem(item))
  }

  getItems () {
    return this.items
  }

  toString () {
    return 'ClientsQueue{' +
      'items=' + '\'' + this.items + '\'' +
      '}'
  }
}

export default ClientsQueue
